import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const MinimapIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="minimap" ref={ref} {...props}>
      <path d="M16.78,20.75H7A3.75,3.75,0,0,1,3.25,17V7A3.75,3.75,0,0,1,7,3.25h9.78A3.75,3.75,0,0,1,20.53,7V17A3.75,3.75,0,0,1,16.78,20.75ZM7,4.75A2.25,2.25,0,0,0,4.75,7V17A2.25,2.25,0,0,0,7,19.25h9.78A2.25,2.25,0,0,0,19,17V7a2.25,2.25,0,0,0-2.25-2.25ZM7,8V10a1,1,0,0,0,1,1H9.89a1,1,0,0,0,1-1V8a1,1,0,0,0-1-1H8A1,1,0,0,0,7,8Z" />
    </Icon>
  ),
) as IconWithRender;

MinimapIcon.displayName = 'MinimapIcon';
MinimapIcon.renderIcon = (props) => <MinimapIcon {...props} />;
export default MinimapIcon;
